import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { arrayOf, number, string, shape } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Price } from '@thd-olt-component-react/price';

import { Typography } from '@one-thd/sui-atomic-components';

export const Pod = ({ lineItemId, product }) => {
  const { channel } = useContext(ExperienceContext);

  const { identifiers, media, pricing } = product || {};
  const { brandName, productLabel } = identifiers || {};
  const imageURL = media?.images?.[0]?.url; // TODO: parse image size. Mocks aren't 100% correct.

  if (!productLabel) {
    return null;
  }

  return (
    <div className="sui-flex sui-mt-2" key={lineItemId}>
      {/* TODO: Image is not square on mobile devices */}
      <img
        src={imageURL}
        width="74"
        height="74"
        className="sui-mr-4 sui-object-contain"
        alt={productLabel}
      />
      <div className="sui-flex sui-flex-col">
        <span>
          <span className="sui-pr-1">
            <Typography component="span" variant="body-base" weight="bold">
              {brandName}
            </Typography>
          </span>
          <Typography component="span" variant="body-base">{productLabel}</Typography>
        </span>
        <span className="sui-mt-1" style={{ minHeight: '28px' }}>
          <Price
            hideBadge
            hideSavingsText
            hidePromotions
            hideBulkPrice
            channel={channel}
            product={{ pricing }}
            itemId=""
            large={false}
            type="simple"
            clsRemediation={{
              placeholders: true,
              preservePlaceholders: true
            }}
          />
        </span>
      </div>
    </div>
  );
};

Pod.propTypes = {
  product: shape({
    identifiers: shape({
      brandname: string,
      productlabel: string,
    }),
    media: shape({
      images: arrayOf(shape({
        url: string
      }))
    }),
    pricing: shape({
      original: number,
      value: number
    })
  }).isRequired,
  lineItemId: string.isRequired
};

Pod.displayName = 'PartsAndServicesPod';
